export default "__VITE_ASSET__DsMKKLfP__"